class HomepageCollectionIconCarouselController extends window.MediaQueryController {
  connect() {
    this.initSwiper();
  }

  initSwiper() {
    if (this.swiper) return;
    this.swiper = new Swiper(".homepage-collection-icon-carousel-swiper", {
      slidesPerView: "auto",
      breakpoints: {
        // when window width is >= 1024px (lg)
        1024: {
          slidesPerView: 6,
        },
      },
      autoplay: false,
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

Stimulus.register(
  "homepage-collection-icon-carousel",
  HomepageCollectionIconCarouselController,
);
